import {Controller, useFormContext} from "react-hook-form";
import {AccountDetailsFormValues} from "../types";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {Select, Space, Spin} from "antd";
import {useGetPayoutBankBranchesQuery} from "../../../../../../../react-query-hooks/payout";
import {BankName, handleBankName} from "../utils";
import {usePayoutSettingsContext} from "../../context";

export function AccountDetailsFormBankBranchFormField({
  isVerifyingAccountNumber,
  isMutationIdle,
  resetMutation,
}: {
  isVerifyingAccountNumber: boolean;
  isMutationIdle: boolean;
  resetMutation: () => void;
}) {
  const {state} = usePayoutSettingsContext();
  const {control, watch, setValue} = useFormContext<AccountDetailsFormValues>();
  const bankCodeValue = watch("bankCode");

  function findBankName(bankCode: string): BankName | undefined {
    return handleBankName({
      banks: state.payoutBanks.banks,
      selectedBank: bankCode,
    });
  }

  const bankName = findBankName(bankCodeValue);

  const bankIdQueryValue = bankName?.hasBankBranch ? bankName.id : null;
  const getPayoutBankBranchesQuery = useGetPayoutBankBranchesQuery({
    bankId: bankIdQueryValue,
  });
  return bankName?.hasBankBranch ? (
    <div>
      <FormField
        id="accountBank"
        label="Branch"
        renderInput={(id) => (
          <Controller
            control={control}
            name="branchCode"
            render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
              <Space direction="vertical" size={16} style={{display: "flex"}}>
                <Select
                  id={id}
                  size="large"
                  status={error?.message ? "error" : undefined}
                  style={{width: "100%"}}
                  onChange={(e) => {
                    if (!isMutationIdle) {
                      resetMutation();
                    }
                    setValue("accountNumber", "");
                    onChange(e);
                  }}
                  value={value}
                  ref={ref}
                  onBlur={onBlur}
                  showSearch
                  options={
                    getPayoutBankBranchesQuery.isLoading
                      ? []
                      : getPayoutBankBranchesQuery.isError
                      ? []
                      : getPayoutBankBranchesQuery.data.data.branches?.data.map(
                          (branch) => ({
                            label: branch.branch_name,
                            value: branch.branch_code,
                          })
                        )
                  }
                  placeholder="Please select"
                  loading={
                    getPayoutBankBranchesQuery.isFetching &&
                    getPayoutBankBranchesQuery.isLoading
                  }
                  disabled={
                    getPayoutBankBranchesQuery.isLoading ||
                    getPayoutBankBranchesQuery.isFetching ||
                    getPayoutBankBranchesQuery.isError ||
                    !bankCodeValue ||
                    isVerifyingAccountNumber
                  }
                  optionFilterProp="children"
                  filterOption={(input, option) => {
                    if (option) {
                      return option.label.toLowerCase().includes(input.toLowerCase());
                    } else {
                      return false;
                    }
                  }}
                  notFoundContent={
                    getPayoutBankBranchesQuery.isLoading ||
                    getPayoutBankBranchesQuery.isFetching ? (
                      <Spin />
                    ) : null
                  }
                />
                <FormFieldError errorMessage={error?.message} />
              </Space>
            )}
          />
        )}
      />
    </div>
  ) : null;
}
